import React from "react";
import { Button as AntButton } from "antd";
import styled from "styled-components";
import { EditOutlined, LeftOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Search from "components/inputs/Search";
import Fetch from "components/Fetch";
import Loading from "components/App/Loading";
import { Header } from "components/App/styled";
import DeleteButton from "components/buttons/DeleteButton";
import BackBtn from "components/buttons/BackBtn";
import { StyledModal } from "components/App/styled";
import { List, ListRow } from "components/Tables/List";

import Manage from "./Manage";

export default function Customers({ returnPage }) {
  const [initialData, setInitialData] = React.useState([]);
  const [data, setData] = React.useState(null);
  const [update, setUpdate] = React.useState(null);
  const [reload, setReload] = React.useState(false);

  React.useEffect(() => {
    Fetch.get("/customer", (res) => {
      console.log(res);
      setData(res.customers);
      setInitialData(res.customers);
    });
    setReload(false);
  }, [reload]);

  const handleCancel = () => {
    setUpdate(null);
  };
  function handleSearch({ target }) {
    const { value } = target;
    var newProducts = initialData;
    if (value) {
      newProducts = newProducts.filter(
        (item) => item.name.includes(value) && item
      );
    }
    setData(newProducts);
  }
  return (
    <Container>
      <Col>
        <HeaderContainer>
          <Header> اضافه کردن مشتری</Header>
          <BackBtn onClick={returnPage} />
        </HeaderContainer>
        <Manage data={data} setData={setData} key="new-customer" />
      </Col>

      <ColLeft>
        <Header>لیست مشتری ها</Header>
        <Search
          placeholder="جستجو..."
          onChange={handleSearch}
          style={{ marginBottom: 20, marginTop: -10, borderRadius: 6 }}
        />
        <List>
          <ListRow
            style={{
              borderBottom: `1px solid ${colors.dark}`,
              paddingBottom: 4,
              marginBottom: 8,
              fontWeight: "bold",
            }}
          >
            <span className="title-row">نام مشتری</span>
            <span>نام فروشگاه</span>
          </ListRow>
          {data?.length ? (
            data.map((item, index) => (
              <ListRow key={index}>
                <span className="title-row">{item.name}</span>
                <span>
                  <Button
                    style={{ padding: "6px 1px" }}
                    onClick={() => setUpdate(item)}
                  >
                    <EditOutlined />
                  </Button>
                  <DeleteButton
                    style={{ padding: "6px 1px" }}
                    id={item.id}
                    reload={setReload}
                    title="مشتری"
                    link="customer"
                  />
                </span>
              </ListRow>
            ))
          ) : data?.length === 0 ? (
            <div className="center" style={{ height: 200 }}>
              نتیجه ای یافت نشد
            </div>
          ) : (
            <div style={{ height: 200 }}>
              <Loading />
            </div>
          )}
        </List>
      </ColLeft>

      <StyledModal
        title={"به روز رسانی"}
        visible={update ? true : false}
        // onOk={onSubmit}
        onCancel={handleCancel}
        closable={false}
        footer={[]}
        width={680}
      >
        <Manage
          data={data}
          setData={setData}
          oldData={update}
          handleCancel={handleCancel}
          key={update?.id}
        />
      </StyledModal>
    </Container>
  );
}
const Container = styled.div`
  display: flex;
  padding: 26px 20px;

  @media (max-width: 1280px) {
    flex-direction: column;
    min-height: calc(100vh - 210px);
  }
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;

  @media (max-width: 1280px) {
    margin-right: 0;
  }
`;
const ColLeft = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  margin-right: 64px;

  width: calc(100% - 300px);

  @media (max-width: 1280px) {
    margin-top: 36px;
    margin-right: 0;
    width: 100%;
  }
`;
